let cardConfig = [{ span: 14, height: "109px", classes: "marginTop-16" }]

const closedStep = [
    { span: 14, height: "112px", classes: "marginTop-24" },
    { span: 14, height: "112px", classes: "marginTop-16" },
]

const openStep = [{ span: 14, height: "320px", classes: "marginTop-16" }]

const cta = { span: 12, height: "80px", classes: "marginTop-64 marginAuto" }

const LeadPageConfig = [...cardConfig, ...closedStep, ...openStep, cta]
export default LeadPageConfig
